import { axios } from '@/services/axios';

/**
 * Creates an address and optionally links it to one or more platforms.
 *
 * @param {object} addressData - PingCo address payload. Include
 *   `autoAddToNew: true` and `addToPlatforms: [platformID]` to create a
 *   platform-linked address (e.g. an 8x8 platform address).
 * @returns {Promise<object>} the created address record.
 */
const createAddress = async (addressData) => {
    const res = await axios.post('/address', addressData);
    return res.data;
};

export default createAddress;
